export default __webpack_public_path__ + "static/media/c001-student-3.cf7fb650.jpg";